var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTegetatrucksEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 850.4 346.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #35393c;\n      }\n\n      .st1 {\n        fill: #ed1651;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    y: 202.6,
    width: 850.4,
    height: 31.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "13 38.5 59.6 38.5 59.6 152.5 95.3 152.5 95.3 38.5 141.9 38.5 141.9 2.8 13 2.8 13 38.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "160.6 152.5 278 152.5 278 116.8 196.4 116.8 196.4 95 255.7 95 255.7 59.3 196.4 59.3 196.4 38.5 278 38.5 278 2.8 160.6 2.8 160.6 152.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.7,35.7h8.7c15.2,0,21.4,5.9,23.3,21.7h36.3c-.9-42.9-27.3-57.5-59.6-57.5h-8.7c-32.9,0-59.9,14.9-59.9,59.6v36c0,44.7,27,59.6,59.9,59.6h8.7c32.9,0,59.6-15.2,59.6-59.6v-25.5h-64v32.6h26.9c-2.5,12.1-9,16.8-22.6,16.8h-8.7c-18.6,0-24.2-8.7-24.2-33.5v-16.8c0-24.8,5.6-33.5,24.2-33.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "448.5 152.5 565.9 152.5 565.9 116.8 484.2 116.8 484.2 95 543.6 95 543.6 59.3 484.2 59.3 484.2 38.5 565.9 38.5 565.9 2.8 448.5 2.8 448.5 152.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "713.6 2.8 584.7 2.8 584.7 38.5 631.3 38.5 631.3 152.5 667 152.5 667 38.5 713.6 38.5 713.6 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M802.5,152.5h37.3L792.3,2.8h-47.5l-47.5,149.7h37.3l6.6-20.8,54.7-.2,6.7,21.1ZM752,97.7l16.6-52.2,16.5,52-33.1.3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.8,288H15v-12.2h53.3v12.2h-18.7v57.2h-15.8v-57.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.2,275.8h24.9c16.4,0,26.8,6.7,26.8,21.1v.4c0,10.5-6.1,16-14.3,18.4l18.4,29.5h-16.7l-16.6-26.8h-6.8v26.8h-15.6v-69.4ZM102.6,307.7c7.9,0,11.8-3.3,11.8-10v-.4c0-7.1-4.3-9.5-11.8-9.5h-8.8v19.9h8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.9,318.1v-42.3h15.8v41.4c0,11.6,3.4,16.6,12.9,16.6s13.4-4.5,13.4-17.2v-40.8h15.8v41.8c0,18.9-10.6,28.7-29.3,28.7s-28.6-9.7-28.6-28.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.6,310.9v-.8c0-21.1,14.8-35.4,34.5-35.4s29.1,8.2,30.8,25.2h-16.1c-1.2-8.3-5.8-12.8-14.6-12.8s-18,8.5-18,22.9v.8c0,14.4,6.6,22.7,18.1,22.7s14.7-4.4,15.9-13.3h15.4c-1.7,17.2-14.1,26-31.2,26s-34.9-14-34.9-35.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.8,275.8h15.7v29.9l24.3-30h16.7l-27.5,32.9,28.8,36.6h-18.4l-24-31.2v31.2h-15.7v-69.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.6,323.4h15c.7,6.2,3.3,11.4,13.6,11.4s11.5-3.8,11.5-9.2-2.9-7.5-13.1-9c-17.8-2.3-25-7.7-25-21.1s9.9-20.7,25.2-20.7,24.8,7,26,20.8h-14.5c-1-6.3-4.7-9.2-11.6-9.2s-10.4,3.2-10.4,7.9,2.2,7.3,12.9,8.8c16.8,2.1,25.4,6.7,25.4,21.1s-10.1,22.1-26.5,22.1-27.8-8.9-28.6-22.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTegetatrucksEn);
export default __webpack_public_path__ + "static/media/TEGETATRUCKS_EN.e4ff7d3296f4fc38278398f9587362ae.svg";
export { ForwardRef as ReactComponent };